import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ReactComponent as Check } from "assets/images/icons/Check.svg";

export function getNameAndEmailFromString(nameAndEmail: string) {
  const [name, email] = nameAndEmail.split(" (");
  return {
    name,
    email: email ? email.slice(0, -1) : "",
  };
}

export function FirstFourApprovers({ approvers }: { approvers?: string[] }) {
  const [copiedIndex, setCopiedIndex] = useState<number>();

  const handleClickName = (email: string, index: number) => {
    navigator.clipboard.writeText(email).then(() => {
      setCopiedIndex(index);
      setTimeout(() => {
        setCopiedIndex(undefined);
      }, 1000);
    });
  };

  if (!approvers || approvers.length === 0) return null;

  const firstFourApprovers = approvers.slice(0, 4).map((approver: string) => getNameAndEmailFromString(approver));
  return (
    <>
      {firstFourApprovers.map(({ name, email }, index) => (
        <React.Fragment key={index}>
          <span
            onClick={() => handleClickName(email, index)}
            className="cursor-pointer"
            style={{ display: "inline-block", whiteSpace: "nowrap" }}
          >
            <OverlayTrigger
              overlay={
                <Tooltip id={`${name}-email-${index}`}>
                  <div className="d-flex align-items-center gap-xxs py-xxs">
                    <strong>{email}</strong>
                    {copiedIndex === index && <Check width={14} height={14} />}
                  </div>
                </Tooltip>
              }
            >
              <span>{name}</span>
            </OverlayTrigger>
          </span>
          {index < firstFourApprovers.length - 1 && ", "}
        </React.Fragment>
      ))}
    </>
  );
}

FirstFourApprovers.defaultProps = {
  approvers: [],
};
